getResolvers